import { render, staticRenderFns } from "./VariableForm.vue?vue&type=template&id=b81c648c"
import script from "./VariableForm.vue?vue&type=script&lang=js"
export * from "./VariableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports